import { PLP_ROOT_ID } from "./consts";

const getPLPRoot = () => document.getElementById(PLP_ROOT_ID);

export default getPLPRoot;
